import { useTranslation } from 'react-i18next';
import PageHeader from '../components/common/PageHeader';
import SEO from '../components/common/SEO';

const Donations = () => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col min-h-screen bg-background-primary">
      <SEO 
        title={t('donations.header')}
        description={t('donations.subheader')}
        keywords={[
          'Jewish donations',
          'Torah support',
          'Jewish education support',
          'Tzedakah',
          'Jewish charity',
          'Support Jewish learning'
        ]}
      />
      <PageHeader
        title={t('donations.header')}
        description={t('donations.subheader')}
      />
    </div>
  );
};

export default Donations; 